"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const hauling_types_1 = require("./hauling.types");
const adjustment_1 = require("services/adjustment");
const planning_types_1 = require("../planning.types");
const getDataGridHauling = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridHauling)(dataStates);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: hauling_types_1.planningHaulingTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        if (response.data.length > 0) {
            payload.dataGrid = payload.dataGrid.concat(Object.assign(Object.assign({}, response.totalOnMonth), { contractor_code: 'Total' }));
            // payload.dataGrid = payload.dataGrid.concat({
            //   ...response.data[response.data.length - 1],
            //   contractor_code: 'Total',
            //   unit: response.data.reduce(function (a, b) { return a + b.unit}, 0),
            //   trip: response.data.reduce(function (a, b) { return a + b.trip}, 0),
            //   jan: response.data.reduce(function (a, b) { return a + b.jan}, 0),
            //   feb: response.data.reduce(function (a, b) { return a + b.feb}, 0),
            //   mar: response.data.reduce(function (a, b) { return a + b.mar}, 0),
            //   apr: response.data.reduce(function (a, b) { return a + b.apr}, 0),
            //   mei: response.data.reduce(function (a, b) { return a + b.mei}, 0),
            //   jun: response.data.reduce(function (a, b) { return a + b.jun}, 0),
            //   jul: response.data.reduce(function (a, b) { return a + b.jul}, 0),
            //   aug: response.data.reduce(function (a, b) { return a + b.aug}, 0),
            //   sep: response.data.reduce(function (a, b) { return a + b.sep}, 0),
            //   oct: response.data.reduce(function (a, b) { return a + b.oct}, 0),
            //   nov: response.data.reduce(function (a, b) { return a + b.nov}, 0),
            //   dec: response.data.reduce(function (a, b) { return a + b.dec}, 0),
            // })
        }
        dispatch({ type: hauling_types_1.planningHaulingTypes.SET_DATA_GRID_HAULING, payload });
        dispatch({
            type: planning_types_1.adjustmentPlanningTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: false, isLoading: false }
        });
    }
});
const getDataGridHaulingBrand = (dataStatesBrand) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridHaulingBrand)(dataStatesBrand);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: hauling_types_1.planningHaulingTypes.SET_ERROR, payload });
    }
    else {
        const dataBrand = response.data.dataHaulingOnBrand;
        const payload = {
            count: response.countData,
            dataTotal: response.data.totalOnMonth,
            lastUpdatedBrand: dataBrand.length > 0 ? dataBrand[0].modified_date : null,
            dataGridBrand: response.isError ? [] : dataBrand.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: hauling_types_1.planningHaulingTypes.SET_DATA_GRID_HAULING_BRAND, payload });
        dispatch({
            type: planning_types_1.adjustmentPlanningTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: false, isLoading: false }
        });
    }
});
const getDataGridHistory = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridHistoryHauling)(dataStatesHistory);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: planning_types_1.adjustmentPlanningTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGridHistory: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { uploaded_at: new Date(item.uploaded_at) });
            })
        };
        dispatch({ type: hauling_types_1.planningHaulingTypes.SET_DATA_GRID_HISTORY, payload });
    }
});
const getLastSucceedUpload = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridHistoryHauling)(dataStatesHistory);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: planning_types_1.adjustmentPlanningTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            lastUpdated: response.data.length > 0 ? response.data[0].uploaded_at : null,
        };
        dispatch({ type: hauling_types_1.planningHaulingTypes.SET_LAST_SUCCEED_UPLOAD, payload });
    }
});
const onUploadDocumentHauling = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { formdata, filename, year } = payload;
    const responseUpload = yield (0, adjustment_1._uploadDocumentHauling)(formdata);
    const responseProcess = yield (0, adjustment_1._uploadProcessHauling)({ filename, year });
    if (responseUpload.isError || responseProcess.isError) {
        const payload = {
            isError: responseUpload.isError || responseProcess.isError,
            errorCode: responseUpload.errorCode || responseProcess.errorCode,
            errorMessage: responseUpload.errorMessage || responseProcess.errorMessage,
        };
        dispatch({ type: hauling_types_1.planningHaulingTypes.SET_ERROR, payload });
    }
    else {
        dispatch({
            type: hauling_types_1.planningHaulingTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: false, isLoadingUpload: false, selectedYear: year }
        });
        dispatch({
            type: planning_types_1.adjustmentPlanningTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: false, isSuccess: true, isLoading: true }
        });
    }
});
const onDownloadTemplateDocument = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._downloadTemplateHauling)(payload);
    if (response.isError) {
        dispatch({ type: hauling_types_1.planningHaulingTypes.SET_ERROR, payload: response });
    }
    else {
        window.location.href = response.url;
        dispatch({
            type: hauling_types_1.planningHaulingTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: payload.mutationMode, isLoadingDownload: false }
        });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: hauling_types_1.planningHaulingTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: hauling_types_1.planningHaulingTypes.ON_MUTATION_CLICK, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: hauling_types_1.planningHaulingTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: hauling_types_1.planningHaulingTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: hauling_types_1.planningHaulingTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
//HISTORY
const onSortChangeHistory = payload => dispatch => {
    dispatch({ type: hauling_types_1.planningHaulingTypes.ON_SORT_CHANGE_HISTORY, payload });
};
const onFilterChangeHistory = payload => dispatch => {
    dispatch({ type: hauling_types_1.planningHaulingTypes.ON_FILTER_CHANGE_HISTORY, payload });
};
const onDataStateChangeHistory = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: hauling_types_1.planningHaulingTypes.ON_PAGE_CHANGE_HISTORY, payload: { dataStatesHistory } });
});
// BRAND
const onSortChangeBrand = payload => dispatch => {
    dispatch({ type: hauling_types_1.planningHaulingTypes.ON_SORT_CHANGE_BRAND, payload });
};
const onFilterChangeBrand = payload => dispatch => {
    dispatch({ type: hauling_types_1.planningHaulingTypes.ON_FILTER_CHANGE_BRAND, payload });
};
const onDataStateChangeBrand = (dataStatesBrand) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: hauling_types_1.planningHaulingTypes.ON_PAGE_CHANGE_BRAND, payload: { dataStatesBrand } });
});
const onSaveDataBrandItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { mutationMode } = payload;
    const response = yield (0, adjustment_1._editBrand)({
        brand_id_rs: payload.dataItemBrand.brand_id_rs || '',
        brand_id_sm: payload.dataItemBrand.brand_id_sm || '',
        brand_data_rs: String(payload.dataItemBrand.brand_data_rs || 0),
        brand_data_sm: String(payload.dataItemBrand.brand_data_sm || 0),
        month: (_a = payload.dataItemBrand.month) === null || _a === void 0 ? void 0 : _a.slice(0, 3).toLowerCase(),
        year: payload.dataItemBrand.year
    });
    const dataItemBrand = Object.assign({}, payload.dataItemBrand);
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({
            type: hauling_types_1.planningHaulingTypes.ON_SAVE_DATAITEM,
            payload: Object.assign(Object.assign({}, payload), { dataItemBrand, mutationMode, isSuccess })
        });
        dispatch({
            type: planning_types_1.adjustmentPlanningTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: false, isSuccess: false, isLoading: true, dataItemBrand }
        });
    }
    else {
        dispatch({ type: hauling_types_1.planningHaulingTypes.SET_ERROR, payload: response });
    }
});
exports.default = {
    onSortChange,
    onCloseError,
    onFilterChange,
    onClickMutation,
    onDataStateChange,
    onSortChangeBrand,
    getDataGridHistory,
    getDataGridHauling,
    onSortChangeHistory,
    onFilterChangeBrand,
    onSaveDataBrandItem,
    getLastSucceedUpload,
    onFilterChangeHistory,
    onDataStateChangeBrand,
    onUploadDocumentHauling,
    getDataGridHaulingBrand,
    onDataStateChangeHistory,
    onDownloadTemplateDocument,
};
